import React, { useState, useEffect } from 'react'
import { Steps, Space} from 'antd'
import { useTDspListQuery} from '../../store/DianShangYeWuApi'
import ReportCheckNodeApprove from './ReportCheckNodeApprove';
import ReportCheckNodeApproveEdit from './ReportCheckNodeApproveEdit';
function ReportCheckNode(props) {   
    console.log(props,'props');
    
    const {data, isSuccess} = useTDspListQuery({dsbzd_sp_dsbzd_id:props.dsbzd_id},{skip:!props.dsbzd_id});  
    //设置步骤条
    const [items, setItems] = useState([]); 
    //设置当前点亮的步骤条
    const [current, setCurrent] = useState(0);
    useEffect(() => {
        if(isSuccess && data){
            if(data.Status === 'success' && data.Result){
                // 然后 map，判断是否是最后一个元素
                const newArr =  data.Result.map(item => {
                    const {
                        dsbzd_sp_jd_name,
                        dsbzd_sp_yh_name,
                        dsbzd_sp_yh_id,
                        dsbzd_sp_jd_xuhao,
                        dsbzd_sp_content,
                        dsbzd_sp_id,
                        dsbzd_sp_dsbzd_id,
                        dsbzd_sp_dsbzd_name,
                        dsbzd_sp_state,
                        dsbzd_sp_state_time,
                        dsbzd_sp_uname,
                        dsbzd_sp_ctime,
                        dsbzd_sp_dsbzd_date,
                        dsbzd_sp_dsbzd_date_end,
                        dsbzd_sp_dsbzd_kh_id,
                        dsbzd_sp_dsbzd_kh_name,
                    } = item;
                    return {
                        dsbzd_sp_jd_name,
                        dsbzd_sp_yh_name,
                        dsbzd_sp_yh_id,
                        dsbzd_sp_jd_xuhao,
                        dsbzd_sp_content,
                        dsbzd_sp_id,
                        dsbzd_sp_dsbzd_id,
                        dsbzd_sp_dsbzd_name,
                        dsbzd_sp_state,
                        dsbzd_sp_state_time,
                        dsbzd_sp_uname,
                        dsbzd_sp_ctime,
                        dsbzd_sp_dsbzd_date,
                        dsbzd_sp_dsbzd_date_end,
                        dsbzd_sp_dsbzd_kh_id,
                        dsbzd_sp_dsbzd_kh_name,
                    }                
                })
                // 排序数据
                const sortedData = newArr.sort((a, b) => {
                    return a.dsbzd_sp_jd_xuhao - b.dsbzd_sp_jd_xuhao;
                });
                // 生成 arr 并计算 current
                let firstApproveWithState2Index = -1; // 在 arr 中的索引（状态为 '2' 的审批点）
                let lastItemIndex = -1; // 在 arr 中的最后一个 item 的索引
                let arrIndex = 0; // arr 的当前索引
                
                const arr = sortedData.map((item) => {
                    let result = null;
                    if(item.dsbzd_sp_jd_name === '审批' && item.dsbzd_sp_state==='1'){
                        result = {
                            title:<span style={{fontSize:"14px",fontWeight:"bold"}}>审批</span>,
                            content:<span style={{fontSize:"12px"}}>{item.dsbzd_sp_yh_name}</span>,
                            dsbzd_sp_state:item.dsbzd_sp_state,
                        }
                        lastItemIndex = arrIndex;
                        arrIndex++;
                    }
                    else if(item.dsbzd_sp_jd_name === '审批' && item.dsbzd_sp_state==='2'){
                        result = {
                            title:<span style={{fontSize:"14px",fontWeight:"bold"}}>审批</span>,
                            content:props.yh_id===item.dsbzd_sp_yh_id ? <ReportCheckNodeApprove 
                                                                            sortedData={sortedData}
                                                                            yh_id={props.yh_id} 
                                                                            yh_name={props.yh_name} 
                                                                            dsbzd_id={props.dsbzd_id}
                                                                            dsbzd_name={props.dsbzd_name}
                                                                            dsbzd_date={props.dsbzd_date}
                                                                            dsbzd_date_end={props.dsbzd_date_end}
                                                                            dsbzd_kh_id={props.dsbzd_kh_id}
                                                                            dsbzd_kh_name={props.dsbzd_kh_name}
                                                                            dsbzd_sp_id={item.dsbzd_sp_id}
                                                                            dsbzd_sp_jd_xuhao={item.dsbzd_sp_jd_xuhao}
                                                                            dsbzd_sp_jd_name={item.dsbzd_sp_jd_name}
                                                                            dsbzd_sp_yh_id={item.dsbzd_sp_yh_id}
                                                                            dsbzd_sp_yh_name={item.dsbzd_sp_yh_name}
                                                                            dsbzd_sp_uid={item.dsbzd_sp_uid}
                                                                            dsbzd_sp_uname={item.dsbzd_sp_uname}
                                                                        /> : <span style={{fontSize:"12px"}}>{item.dsbzd_sp_yh_name}</span>,
                             dsbzd_sp_state:item.dsbzd_sp_state,
                                                                        
                        }
                        // 找到第一个状态为 '2' 的审批点
                        if(firstApproveWithState2Index === -1){
                            firstApproveWithState2Index = arrIndex;
                        }
                        lastItemIndex = arrIndex;
                        arrIndex++;
                    }
                    else if(item.dsbzd_sp_jd_name === '审批' && (item.dsbzd_sp_state==='3' || item.dsbzd_sp_state==='4' || item.dsbzd_sp_state==='5')){
                        result = {
                            title:<span style={{fontSize:"14px",fontWeight:"bold"}}>审批</span>,
                            content:props.yh_id===item.dsbzd_sp_yh_id ? <ReportCheckNodeApproveEdit 
                                                                            sortedData={sortedData}
                                                                            yh_id={props.yh_id} 
                                                                            yh_name={props.yh_name} 
                                                                            dsbzd_id={props.dsbzd_id}
                                                                            dsbzd_name={props.dsbzd_name}
                                                                            dsbzd_date={props.dsbzd_date}
                                                                            dsbzd_date_end={props.dsbzd_date_end}
                                                                            dsbzd_kh_id={props.dsbzd_kh_id}
                                                                            dsbzd_kh_name={props.dsbzd_kh_name}
                                                                            dsbzd_sp_id={item.dsbzd_sp_id}
                                                                            dsbzd_sp_jd_xuhao={item.dsbzd_sp_jd_xuhao}
                                                                            dsbzd_sp_jd_name={item.dsbzd_sp_jd_name}
                                                                            dsbzd_sp_yh_id={item.dsbzd_sp_yh_id}
                                                                            dsbzd_sp_yh_name={item.dsbzd_sp_yh_name}
                                                                            dsbzd_sp_uid={item.dsbzd_sp_uid}
                                                                            dsbzd_sp_uname={item.dsbzd_sp_uname}
                                                                            dsbzd_sp_state={item.dsbzd_sp_state}
                                                                            dsbzd_sp_state_time={item.dsbzd_sp_state_time}
                                                                            dsbzd_sp_content={item.dsbzd_sp_content}
                                                                        />: <Space orientation='vertical' size={0}>
                                                                                <span style={{color:item.dsbzd_sp_state==='4' ? 'red' : 'green',fontWeight:"bold"}}>
                                                                                    {item.dsbzd_sp_state==='4' ? '驳回' : '同意'}
                                                                                    {item.dsbzd_sp_content? '：'+item.dsbzd_sp_content :''}
                                                                                </span>
                                                                                <span>{item.dsbzd_sp_yh_name} {item.dsbzd_sp_state_time} </span>
                                                                            </Space>,
                                                                            dsbzd_sp_state:item.dsbzd_sp_state,
                        }
                        lastItemIndex = arrIndex;
                        arrIndex++;
                    }
                    else if(item.dsbzd_sp_jd_name === '抄送' && item.dsbzd_sp_state==='1'){
                        result = {
                            title:<span style={{fontSize:"14px",fontWeight:"bold"}}>抄送</span>,
                            content:<span style={{fontSize:"12px"}}>{item.dsbzd_sp_yh_name}</span>,
                            dsbzd_sp_state:item.dsbzd_sp_state,
                        }
                        lastItemIndex = arrIndex;
                        arrIndex++;
                    }
                    else if(item.dsbzd_sp_jd_name === '抄送' && item.dsbzd_sp_state==='2'){
                        result = {
                            title:<span style={{fontSize:"14px",fontWeight:"bold"}}>抄送</span>,
                            content:<span style={{fontSize:"12px"}}>{item.dsbzd_sp_yh_name}</span>,
                            dsbzd_sp_state:item.dsbzd_sp_state,
                        }
                        lastItemIndex = arrIndex;
                        arrIndex++;
                    }
                    else if(item.dsbzd_sp_jd_name === '抄送' && item.dsbzd_sp_state==='3'){
                        result = {
                            title:<span style={{fontSize:"14px",fontWeight:"bold"}}>抄送</span>,
                            content:<span style={{fontSize:"12px"}}>{item.dsbzd_sp_yh_name} {item.dsbzd_sp_state_time}</span>,
                            dsbzd_sp_state:item.dsbzd_sp_state,
                        }
                        lastItemIndex = arrIndex;
                        arrIndex++;
                    }
                    return result;
                })
                
                // 计算 current，规则优先级：'2' > '4' > 最后一个
                let calculatedCurrent = 0;
                let firstApproveWithState4Index = -1;

                // 查找 '2' 和 '4' 的索引
                arr.forEach((item, idx) => {
                    console.log(item);
                    
                    if (item && item.dsbzd_sp_state === '2' && firstApproveWithState2Index === -1) {
                        firstApproveWithState2Index = idx;
                    }
                    if (item && item.dsbzd_sp_state === '4' && firstApproveWithState4Index === -1) {
                        firstApproveWithState4Index = idx;
                    }
                });

                if (firstApproveWithState2Index !== -1) {
                    calculatedCurrent = firstApproveWithState2Index;
                } else if (firstApproveWithState4Index !== -1) {
                    calculatedCurrent = firstApproveWithState4Index;
                } else if (lastItemIndex !== -1) {
                    calculatedCurrent = lastItemIndex;
                }

                // current 需要加上前面的"创建"和"提交"两个步骤
                setCurrent(calculatedCurrent + 2);
                setItems([{
                    title:<span style={{fontSize:"14px",fontWeight:"bold"}}>创建</span>,
                    content:<span style={{fontSize:"14px"}}>{props.dsbzd_uname} {props.dsbzd_ctime}</span>,
                },
                {
                    title:<span style={{fontSize:"14px",fontWeight:"bold"}}>提交</span>,
                    content:<span style={{fontSize:"14px"}}>{props.dsbzd_uname} {props.dsbzd_state_time}</span>,
                },...arr]);
                
            } else {
                setItems([]);
            }
        }
    },[data, isSuccess, props])   
    return (
        <Steps items={items} current={current} size="small" titlePlacement="vertical" />
    )
}

export default ReportCheckNode